import { CurrencyService } from "../services/CurrencyService";
import { TrvCryptoService } from "../services/TrvCryptoService";
import { formatMoney, formatPercent } from "../utils/formatters";
// import currenciesData from "../../../../../currencies-data.json";

export class CurrenCySelector {
  private wrapper: JQuery<HTMLElement>;
  private toggleButton: JQuery<HTMLElement>;
  private clearButton: JQuery<HTMLElement>;
  private input: JQuery<HTMLInputElement>;
  private static readonly WRAPPER_OPEN_CLASS = "currency-selector-open";
  private static readonly VARIATION_POSITIVE_CLASS =
    "currency-selector-currency-variation-green";
  private static readonly VARIATION_NEGATIVE_CLASS =
    "currency-selector-currency-variation-red";
  private static readonly LOADING_CLASS = "currency-selector-loading";
  private itemTemplate: JQuery<HTMLElement>;
  private searchParams: URLSearchParams;

  constructor() {
    this.wrapper = $(".currency-selector-module-wrapper");
    this.toggleButton = this.wrapper.find(".currency-selector-currency");
    this.clearButton = this.wrapper.find(".currency-selector-search-close");
    this.input = this.wrapper.find<HTMLInputElement>(
      ".currency-selector-search-input"
    );
    this.itemTemplate = this.wrapper.find(".currency-selector-item-template");
    this.wrapper.addClass(CurrenCySelector.LOADING_CLASS);

    this.renderItems();

    this.toggleButton.on("click", this.onToggleButtonClick.bind(this));

    this.clearButton.on("click", this.onClearButtonClick.bind(this));
    // @ts-ignore
    this.input.on("input", this.onInputKeyUp.bind(this));
    this.wrapper.on("mouseleave", this.onWrapperMouseLeave.bind(this));
    // this.wrapper.on(
    //   "click",
    //   ".currency-selector-item",
    //   this.onItemClick.bind(this)
    // );
    this.searchParams = new URLSearchParams(location.search);

    this.setSelected();
  }

  private async setSelected() {
    const selected = await CurrencyService.getSelected();

    this.setCurrency(selected!!);
  }

  private onToggleButtonClick(e: JQuery.ClickEvent) {
    e.preventDefault();
    this.toggle();
  }

  private onClearButtonClick(e: JQuery.ClickEvent) {
    e.preventDefault();
    this.clearSearch();
  }

  private onInputKeyUp(e: JQuery.KeyUpEvent) {
    const search = this.input.val() as String;
    this.filterItems(search);
  }

  private onWrapperMouseLeave(e: JQuery.MouseLeaveEvent) {
    this.close();
  }

  private async renderItems() {
    const list = this.wrapper.find(".currency-selector-list");
    if (!list.length) {
      return;
    }

    const items = await TrvCryptoService.getTicker();
    const $items = items.map((item) => {
      const $item = $(this.itemTemplate.html());
      $item.attr("href", `/grafico-${item.name.toLowerCase()}`);

      $item
        .find(".currency-selector-item-icon")
        .html("")
        .append($("<img>", { src: item.icon }));
      $item.find(".currency-selector-item-name").html(item.name);
      $item.find(".currency-selector-item-currency").html(item.symbol);
      $item
        .find(".currency-selector-item-sell-price")
        .html(formatMoney(item.price)!!);
      $item
        .find(".currency-selector-currency-variation")
        .html(`${item.priceChange24hPercent.toFixed(2)}%`)
        .addClass(
          item.priceChange24hPercent >= 0
            ? CurrenCySelector.VARIATION_POSITIVE_CLASS
            : CurrenCySelector.VARIATION_NEGATIVE_CLASS
        );

      $item.data("currency", item.symbol);

      return $item;
    });

    list.html("").append($items);

    this.wrapper.removeClass(CurrenCySelector.LOADING_CLASS);
  }

  // private onItemClick(e: JQuery.ClickEvent) {
  //   const $item = $(e.currentTarget);
  //   const code = $item.data("currency");
  //   // const data = currenciesData as { [key: string]: { "page-link": string } };
  //   // const link = data[code]?.["page-link"];

  //   if (link) {
  //     location.href = link;
  //   }
  // }

  toggle() {
    this.wrapper.toggleClass(CurrenCySelector.WRAPPER_OPEN_CLASS);
    this.clearSearch();
  }

  close() {
    this.wrapper.removeClass(CurrenCySelector.WRAPPER_OPEN_CLASS);
    this.clearSearch();
  }

  clearSearch() {
    this.input.val("").trigger("input");
  }

  filterItems(search: String) {
    const $items = this.wrapper.find(".currency-selector-item");
    if (search?.length < 1) {
      $items.show();
      return;
    }

    $items
      .hide()
      .find(".currency-selector-description")
      .filter(`:Contains(${search})`)
      .closest(".currency-selector-item")
      .show();
  }

  setCurrency(currency: Currency) {
    if (!currency?.code) {
      return;
    }
    this.wrapper
      .find(".currency-selector-currency .currency-selector-currency-icon")
      .html("")
      .append($("<img>", { src: currency.icon }));
    this.wrapper
      .find(".currency-selector-currency .currency-selector-currency-name")
      .html(`${currency.name} (${currency.code})`);
    this.wrapper
      .find(".currency-selector-currency .currency-selector-currency-price")
      .html(formatMoney(currency.sellPrice)!!);
    this.wrapper
      .find(".currency-selector-currency .currency-selector-currency-variation")
      .html(formatPercent(currency.variation)!!)
      .addClass(
        currency.variation >= 0
          ? CurrenCySelector.VARIATION_POSITIVE_CLASS
          : CurrenCySelector.VARIATION_NEGATIVE_CLASS
      );
  }
}
